import { App } from 'vue';
import Pagination from '@/components/pagination';

export default function componentsInstall(app: App) {
  app.use(Pagination);
}
